import * as constants from './constants';

const initialState = {
  loading: false,
  data: null,
  nextData: null,
  error: null,
  updatedItems: {},
};

// eslint-disable-next-line import/prefer-default-export
export const itemReducer = (state = initialState, action) => {
  switch (action.type) {
  case constants.GET_ITEM:
  case constants.ITEM_CREATE:
    return { ...state, loading: true };
  case constants.GET_ITEM_SUCCESS:
    return { ...state, loading: false, data: action.payload };
  case constants.GET_ITEM_ERROR:
    return { ...state, loading: false, error: action.payload };
  case constants.RESET_ITEM:
    return initialState;
  case constants.DELETE_ITEMS:
    return { ...state, loading: true };
  case constants.ITEM_CREATE_SUCCESS:
  case constants.DELETE_ITEMS_SUCCESS:
    return { ...state, loading: false };
  case constants.ITEM_CREATE_ERROR:
  case constants.DELETE_ITEMS_ERROR:
    return { ...state, loading: false, error: action.payload };
  case constants.SET_NEXT_ITEM_DATA:
    return { ...state, nextData: action.payload };
  case constants.RESET_NEXT_ITEM_DATA:
    return { ...state, nextData: null };
  case constants.SET_UPDATED_ITEMS:
    return {
      ...state,
      updatedItems: action.payload.ids.reduce((result, id) => ({
        ...result,
        ...(result[id] ? {
          [id]: {
            ...result[id],
            ...action.payload.data,
          },
        } : {
          [id]: action.payload.data,
        }),
      }), {
        ...state.updatedItems,
      }),
    };
  case constants.RESET_UPDATED_ITEMS:
    return {
      ...state,
      updatedItems: {},
    };
  default:
    return state;
  }
};

const initialItemLikeState = {
  loading: false,
  data: {},
  error: null,
};

// eslint-disable-next-line import/prefer-default-export
export const itemLikeReducer = (state = initialItemLikeState, action) => {
  switch (action.type) {
  case constants.ITEM_LIKE:
    return { ...state, loading: true };
  case constants.ITEM_LIKE_SUCCESS:
    return {
      ...state,
      loading: false,
      data: {
        ...state.data,
        [action.payload.id]: true,
      },
    };
  case constants.ITEM_CREATE_ERROR:
    return { ...state, loading: false, error: action.payload.error };
  default:
    return state;
  }
};
